export default "__VITE_ASSET__oTHfeBN2__"